import React from 'react';

import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import styles from '../links/styles';

import type ProviderStore from 'connect/web/src/stores/provider-store';
import type PolicyDialogStore from '../../stores/policy-dialog-store';
import { PolicyType } from '../../stores/policy-dialog-store';

interface IProps extends WithStyles<typeof styles> {
  policyDialogStore?: PolicyDialogStore;
  providerStore?: ProviderStore;
}

@inject('policyDialogStore', 'providerStore')
@observer
class PrivacyPolicy extends React.Component<IProps> {
  render() {
    if (this.show) {
      return null;
    }

    const { classes } = this.props;

    return (
      <a className={classes.link + ' ' + classes.privacy} onClick={this.onOpen}>
        Privacy Policy
      </a>
    );
  }

  @action.bound
  private onOpen(): void {
    const { onOpen } = this.props.policyDialogStore!;
    onOpen(PolicyType.Privacy);
  }

  @computed
  private get show(): boolean {
    return !this.props.providerStore!.privacyPolicy;
  }
}

export default withStyles(styles)(PrivacyPolicy);
